<template>
<div class="Row">
  <cell v-bind:text="title"
        v-bind:isStatic="true"
        v-bind:staleColor="color" />
  <slot />
</div>
</template>

<script>
import Cell from './Cell.vue'

export default {
  name: 'Row',
  components: {
    Cell
  },
  props: {
    title: {
      type: String,
      default: 'Label'
    },
    color: {
      type: String,
      default: 'red'
    }
  },
  methods: {
    activateCell: function () {
      console.log('hello')
    }
  }
}
</script>

<style scoped>
.Row {
  display: flex;
  flex-direction: row;
  column-gap: 1px;
}
</style>
